import React from 'react';
import { useTranslation } from 'react-i18next';
import { TitleHeader } from 'web-library';
import ReviewProfileAmendmentApplicationDetails from '../../../modules/admin/components/ProfileAmendmentRequest/ReviewProfileAmendmentApplicationDetails';

const ReviewProfileAmendmentApplication = () => {
  const { t } = useTranslation();
  return (
    <>
      <TitleHeader title={t('admin->>ProfileAmendmentRequests.CandidateParticulars')} />
      <ReviewProfileAmendmentApplicationDetails />
    </>
  );
};

export default ReviewProfileAmendmentApplication;
